// extracted by mini-css-extract-plugin
export var card = "_q3-0";
export var content = "_q3-2";
export var details = "_q3-3";
export var icon = "_q3-1";
export var iconBlue = "_q3-5";
export var iconBrand = "_q3-4";
export var iconGrayBlue = "_q3-6";
export var iconGreen = "_q3-7";
export var iconIndigo = "_q3-8";
export var iconOrange = "_q3-9";
export var iconPurple = "_q3-a";
export var iconRed = "_q3-b";
export var iconWarning = "_q3-c";